/**
 * default status minutes of handover
 */
export const DEFAULT_STATUS_MINUTES_HANDOVER_SENT = 'sent';
export const DEFAULT_STATUS_MINUTES_HANDOVER_PARTIALLY_SENT = 'partially_sent';
export const DEFAULT_STATUS_MINUTES_HANDOVER_OPEN = 'open';
